module.exports = __webpack_public_path__ + "static/media/favicon.c11d9df3.ico";